import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useLang } from "@/lib/i18n";

export default function LegalLayout({ title, updated, children, testid, path }) {
  const { t } = useLang();
  return (
    <div className="font-body bg-white text-slate-900 min-h-screen" data-testid={testid}>
      <SEO title={title} path={path} />
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="font-heading font-bold text-lg sm:text-xl text-[#0A192F]" data-testid="legal-logo">X10 Management GmbH</Link>
          <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A192F] hover:text-[#1E3A8A]" data-testid="legal-back-link">
            <ArrowLeft size={16} /> {t("legal.back")}
          </Link>
        </div>
      </header>

      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <h1 className="font-heading font-bold text-[#0A192F] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
          {title}
        </h1>
        <div className="mt-3 text-sm uppercase tracking-[0.2em] font-semibold text-slate-500">{updated}</div>
        <div className="mt-12 space-y-8 text-base leading-relaxed text-slate-700 [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-semibold [&_h2]:text-[#0A192F] [&_h2]:mt-12 [&_h2]:mb-4 [&_h3]:font-heading [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-[#0A192F] [&_h3]:mt-8 [&_h3]:mb-3 [&_p]:leading-relaxed [&_a]:text-[#1E3A8A] [&_a]:underline hover:[&_a]:text-[#0A192F] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2">
          {children}
        </div>
      </article>

      <Footer />
    </div>
  );
}
